import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Configuration from "./Configuration";
import History from "./History";
import UserList from "./UserList";
const Connector = () => {
  const dispatch = useDispatch();
  const [menu, setMenu] = useState("user");
  const [openProvisioning, setOpenProvisioning] = useState(false);
  const [minimize, setMinimize] = useState(false);
  const ctiType = useSelector((state) => state.ReduxState.ctiType);

  return (
    <div className="flex flex-col w-full h-screen h-max-screen px-4 justify-between">
      <div className="h-20 flex flex-row w-full">
        <div className="flex items-center text-main-blue text-xs md:text-sm lg:text-2xl px-4 w-1/2 sm:w-1/4">
          <p className="font-bold">CTI Connector</p>
        </div>
        <div className="uppercase flex flex-row items-center sm:text-xs lg:text-sm w-full hidden md:flex">
          <button
            onClick={(e) => setMenu("user")}
            className={
              (menu === "user" ? "text-white bg-main-blue" : "text-black") +
              " h-10 rounded px-5 mx-2"
            }
          >
            <p className="poppins-500">User List</p>
          </button>
          <button
            onClick={(e) => setMenu("config")}
            className={
              (menu === "config" ? "text-white bg-main-blue" : "text-black") +
              " h-10 rounded px-5 mx-2"
            }
          >
            <p className="poppins-500">Configuration</p>
          </button>
          <button
            onClick={(e) => setMenu("history")}
            className={
              (menu === "history" ? "text-white bg-main-blue" : "text-black") +
              " h-10 rounded px-5 mx-2"
            }
          >
            <p className="poppins-500">History</p>
          </button>
        </div>
        <div className="flex items-center text-xs lg:text-base w-full md:w-1/4 justify-end">
          {menu === "config" ? (
            <select
              onChange={(e) => {
                dispatch({ type: "set", ctiType: e.target.value });
              }}
              defaultValue={"zendesk"}
              value={ctiType}
              className="shadow shadow-lg mr-4"
            >
              <option value={"zendesk"}>Zendesk</option>
              <option value={"freshdesk"}>Freshdesk</option>
              <option value={"freshsales"}>Freshsales</option>
            </select>
          ) : (
            ""
          )}
          <button className="flex items-center mr-0 md:hidden">
            <i className="fa-solid fa-bars p-1 border border-black rounded-md"></i>
          </button>
        </div>
      </div>
      {menu === "user" ? (
        <UserList />
      ) : menu === "config" ? (
        <Configuration />
      ) : menu === "history" ? (
        <History />
      ) : (
        ""
      )}
    </div>
  );
};

export default Connector;
